module.exports = __webpack_public_path__ + "static/media/elsa-win.504ad073.png";